import { IState } from 'shared/store';

export const selectBestPlaceReportLegalDocsUrl = (state: IState) => {
  return state.rs.bestPlaceReportLegalDocsUrl;
};
